import { Users, ShieldCheck, Settings, Award } from "lucide-react";

export const excellenceFeatures = [
  {
    icon: Users,
    title: "Профессиональные мастера",
    description:
      "Тщательно отобранные специалисты с многолетним опытом. Никаких случайных работников — только проверенные профессионалы.",
  },
  {
    icon: ShieldCheck,
    title: "Отдел контроля качества",
    description:
      "Ежедневные проверки в процессе работы и финальная приёмка. Проект подписывается только после тщательной проверки.",
  },
  {
    icon: Settings,
    title: "Лучшее оборудование",
    description:
      "Используем топовое, востребованное оборудование от ведущих производителей для достижения идеального результата.",
  },
  {
    icon: Award,
    title: "Качественные материалы",
    description:
      "Работаем только с высококачественными смесями. Строгая ответственность за качество работ.",
  },
] as const;

export const excellenceStats = [
  { value: "1000+", label: "Завершённых проектов по всей ЧР" },
  { value: "0", label: "Недовольных клиентов за всё время" },
  { value: "15", label: "Лет опыта и экспертизы" },
] as const;
